<script>
  export let html
  export let component
</script>
<svelte:component this={component} {...$$restProps}>{@html html}</svelte:component>
